
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateCalculationTemplateVariableDtoFormGroup() {
return new FormGroup({
    calculationTemplateId: new FormControl<number | undefined>(undefined, [Validators.required]),
    variableKey: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100), Validators.pattern(new RegExp("^[a-zA-Z][a-zA-Z0-9_]*$", ""))]),
    label: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    unitLabel: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    description: new FormControl<string | undefined>(undefined, [Validators.maxLength(500)]),
    defaultValue: new FormControl<number | undefined>(undefined),
    sortOrder: new FormControl<number | undefined>(undefined),
})
;
}
      